/******************************************************************************/
function CloseKosaricaKupljeno() {
    if (document.getElementById("kosaricaKratkoKupljeno") !== null) {
        document.getElementById("kosaricaKratkoKupljeno").style.display = "none";
    }
}
/******************************************************************************/
function CloseRegNoviceSucess() {
    if (document.getElementById("noviceRegsucess") !== null) {
        document.getElementById("noviceRegsucess").style.display = "none";
    }
}
/******************************************************************************/
function povecajSlikoArtikla(artikel) {
    if (document.getElementById('slika_art_' + artikel).height > 260) {
        document.getElementById('slika_art_' + artikel).src = 'images/slika.php?page=3&iid=' + artikel + '&width=&height=250';
        document.getElementById('povecaj').innerHTML = 'Povečaj sliko';
        document.getElementById('tabelaArtikelSlika').style.cssFloat = "left";
    } else {
        document.getElementById('slika_art_' + artikel).src = 'images/slika.php?page=3&iid=' + artikel + '&width=520&height=';
        document.getElementById('povecaj').innerHTML = 'Pomanjšaj sliko';
        document.getElementById('tabelaArtikelSlika').style.cssFloat = "none";
    }
}
/******************************************************************************/
function povecajSliko(slika, povecaj, srcBig, widthBig, heightBig, srcMid, widthMid, heightMid, div, float) {
    if (document.getElementById('slika_' + slika).height > heightMid) {
        document.getElementById('slika_' + slika).src = srcMid;
        document.getElementById(povecaj).innerHTML = 'Povečaj sliko';
        document.getElementById('slika_' + slika).width = widthMid;
        document.getElementById('slika_' + slika).height = heightMid;
        document.getElementById(div).style.cssFloat = float;
        document.getElementById(povecaj).style.backgroundPosition = "top left";
    } else {
        document.getElementById('slika_' + slika).src = srcBig;
        document.getElementById(povecaj).innerHTML = 'Pomanjšaj sliko';
        document.getElementById('slika_' + slika).width = widthBig;
        document.getElementById('slika_' + slika).height = heightBig;
        document.getElementById(div).style.cssFloat = "none";
        document.getElementById(povecaj).style.backgroundPosition = "bottom left";
    }
}
/******************************************************************************/
function check_all(field1,
    field2) {
    if (field1.checked) {
        if (field2.length === undefined) {
            field2.checked = true;
        } else {
            for (i = 0; i < field2.length; i++)
                field2[i].checked = true;
        }
    } else {
        if (field2.length === undefined) {
            field2.checked = false;
        } else {
            for (i = 0; i < field2.length; i++)
                field2[i].checked = false;
        }
    }
}
/******************************************************************************/
function is_any_checked(field) {
    if (typeof (field) !== 'undefined' && field !== null) {
        if (field.length === undefined && field.checked) {
            return true;
        } else {
            for (i = 0; i < field.length; i++) {
                if (field[i].checked === true) {
                    return true;
                }
            }
        }
    }
    return false;
}
/******************************************************************************/
function arrayToString(arr, str) {
    var count = 1;
    //  document.getElementById(str).innerHTML = '';
    if (arr.length === undefined) {
        if (arr.checked === true)
            document.getElementById(str).innerHTML = arr.value + '; ';
    } else {
        for (i = 0; i < arr.length; i++) {
            if (arr[i].checked === true) {
                if (count == 1) {
                    document.getElementById(str).innerHTML = arr[i].value + '; ';
                } else {
                    document.getElementById(str).innerHTML = document.getElementById(str).innerHTML + arr[i].value + '; ';
                }
                count = count + 1;
            }
        }
    }
}
/******************************************************************************/
function arrayRemoveFromString(arr, str) {
    var count = 1;
    //  document.getElementById(str).innerHTML = '';
    if (arr.length === undefined) {
        if (arr.checked === false)
            document.getElementById(str).innerHTML = document.getElementById(str).innerHTML.replace(arr.value + '; ', '');
    } else {
        for (i = 0; i < arr.length; i++) {
            if (arr[i].checked === false) {
                if (count == 1) {
                    document.getElementById(str).innerHTML = document.getElementById(str).innerHTML.replace(arr[i].value + '; ', '');
                } else {
                    document.getElementById(str).innerHTML = document.getElementById(str).innerHTML.replace(arr[i].value + '; ', '');
                }
                count = count + 1;
            }
        }
    }
}
/******************************************************************************/
function cookieDetect() {
    if (!navigator.cookieEnabled) {
        document.getElementById('alerts').style.height = 20 + 'px';
        //   document.getElementById('alerts').innerHTML = '<a href="#" rel="nofollow"><img src="/css/tretjeoko/cookiealert.gif" alt="V vašem brskalniku imate onemogočene piškotke!!! Zato nakupovanje v spletni trgovini ni mogoče!!! Več o tem si lahko preberete s klikom na to vrstico." /></a>';
        document.getElementById('alerts').innerHTML = '<img src="/css/tretjeoko/cookiealert.gif" alt="V vašem brskalniku imate onemogočene piškotke!!! Zato nakupovanje v spletni trgovini ni mogoče!!!" width="970" height="20" />';
    }
}
/******************************************************************************/
function myStrToDate(p_datum, p_format) {
    var year;
    var month;
    var day;
    var dateSplit;
    var format = p_format;
    if (!format) {
        format = 'dd.mm.yyyy';
    }
    if (format == 'dd.mm.yyyy') {
        dateSplit = p_datum.split('.');
        day = dateSplit[0];
        month = dateSplit[1];
        year = dateSplit[2];
    }
    // alert(month + '-' + day + '-' + year);
    return Date(month + '-' + day + '-' + year);
}
/******************************************************************************/
function getStranSlikaPodatki(image_id) {
    $.ajax({
        async: true,
        type: "GET",
        url: "/content/arsluna.proccess.php",
        data: {
            "home_id": image_id,
            "p_timestamp": new Date().getTime()
        },
        success: function (result) {
            podatki = result.split('|');
            if (podatki[0] !== undefined) {
                if (document.stran_slika_detajli.stran_slika_ime) {
                    document.stran_slika_detajli.stran_slika_ime.value = podatki[0];
                }
                if (podatki[4] !== undefined && podatki[4] !== '') {
                    if (document.stran_slika_detajli.p_imeStyle) {
                        document.stran_slika_detajli.p_imeStyle.value = podatki[4];
                    }
                    if (document.getElementById('naslov_poglavja')) {
                        document.getElementById('naslov_poglavja').innerHTML = '<' + podatki[4] + '>' + podatki[0] + '</' + podatki[4] + '>';
                    }
                } else {
                    if (document.stran_slika_detajli.p_imeStyle) {
                        document.stran_slika_detajli.p_imeStyle.value = 'p';
                    }
                    if (document.getElementById('naslov_poglavja')) {
                        document.getElementById('naslov_poglavja').innerHTML = '<p>' + podatki[0] + '</p>';
                    }
                }
            } else {
                if (document.stran_slika_detajli.p_imeStyle) {
                    document.stran_slika_detajli.p_imeStyle.value = 'p';
                }
                document.stran_slika_detajli.stran_slika_ime.value = '';
                if (document.getElementById('naslov_poglavja')) {
                    document.getElementById('naslov_poglavja').innerHTML = '';
                }
            }
            var ed;
            if (tinyMCE.get('stran_slika_besedilo_prej')) {
                ed = tinyMCE.get('stran_slika_besedilo_prej');
                if (podatki[1] !== undefined) {
                    ed.setContent(podatki[1]);
                } else {
                    ed.setContent('');
                }
            } else {
                if (podatki[1] !== undefined) {
                    document.stran_slika_detajli.stran_slika_besedilo_prej.value = podatki[1];
                } else {
                    document.stran_slika_detajli.stran_slika_besedilo_prej.value = '';
                }
            }
            if (tinyMCE.get('stran_slika_besedilo_potem')) {
                ed = tinyMCE.get('stran_slika_besedilo_potem');
                if (podatki[2] !== undefined) {
                    ed.setContent(podatki[2]);
                } else {
                    ed.setContent('');
                }
            } else {
                if (podatki[2] !== undefined) {
                    document.stran_slika_detajli.stran_slika_besedilo_potem.value = podatki[2];
                } else {
                    document.stran_slika_detajli.stran_slika_besedilo_potem.value = '';
                }
            }
            document.stran_slika_detajli.prikaz.value = podatki[3];
            document.getElementById('aktivna_slika_title').innerHTML = image_id;
            if (podatki[5] !== undefined) {
                document.stran_slika_detajli.p_responsive_grid_class.value = podatki[5];
            } else {
                document.stran_slika_detajli.p_responsive_grid_class.value = '';
            }
        },
        error: function (r, e) {
            console.log(r);
            console.log(e);
        }
    });
}
/******************************************************************************/
function getArtikelSlikaPodatki(image_id) {
    $.ajax({
        async: true,
        type: "GET",
        url: "/content/arsluna.proccess.php",
        data: {
            "artikel_id": image_id,
            "p_timestamp": new Date().getTime()
        },
        success: function (r) {
            podatki = r.split('|');
            if (document.fmProductPictureDetailEdit.artikel_slika_ime !== null) {
                document.fmProductPictureDetailEdit.artikel_slika_ime.value = '';
                if (podatki[0] !== undefined && document.fmProductPictureDetailEdit.artikel_slika_ime !== null) {
                    document.fmProductPictureDetailEdit.artikel_slika_ime.value = podatki[0];
                }
            }
            if (document.fmProductPictureDetailEdit.artikel_slika_ime !== null) {
                document.fmProductPictureDetailEdit.artikel_slika_title.value = '';
                if (podatki[1] !== undefined) {
                    //document.getElementById('artikel_slika_besedilo_prej').contentWindow.document.body.innerHTML=podatki[1];
                    document.fmProductPictureDetailEdit.artikel_slika_title.value = podatki[1];
                }
            }
            if (document.fmProductPictureDetailEdit.artikel_slika_besedilo_prej !== null) {
                document.fmProductPictureDetailEdit.artikel_slika_besedilo_prej.value = '';
                if (podatki[2] !== undefined) {
                    //document.getElementById('artikel_slika_besedilo_prej').contentWindow.document.body.innerHTML=podatki[1];
                    document.fmProductPictureDetailEdit.artikel_slika_besedilo_prej.value = podatki[2];
                }
            }
            if (document.fmProductPictureDetailEdit.artikel_slika_besedilo_potem !== null) {
                document.fmProductPictureDetailEdit.artikel_slika_besedilo_potem.value = '';
                if (podatki[3] !== undefined) {
                    //document.getElementById('artikel_slika_besedilo_potem').contentWindow.document.body.innerHTML=podatki[2];
                    document.fmProductPictureDetailEdit.artikel_slika_besedilo_potem.value = podatki[3];
                }
            }
        },
        error: function (r, e) {
            console.log(r);
            console.log(e);
        }
    });
}
/******************************************************************************/
function countComercialClick(reklame_pk) {
    $.ajax({
        async: true,
        type: "GET",
        url: "/content/arsluna.proccess.php",
        data: {
            "reklame_pk": reklame_pk,
            "p_timestamp": new Date().getTime()
        },
        success: function (r) { },
        error: function (r, e) {
            console.log(r);
            console.log(e);
        }
    });
}
/******************************************************************************/
function getPosta(stevilka, ev, field1, field2) {
    $.ajax({
        async: true,
        type: "GET",
        url: "/content/arsluna.proccess.php",
        data: {
            "posta": trim(stevilka),
            "p_timestamp": new Date().getTime()
        }
    }).done(function (r) {
        podatki = r.split('|');
        if (podatki[0] !== undefined && podatki[1] !== undefined && key != 8 && key != 46) {
            field1.value = podatki[0];
            field2.value = podatki[1];
            var iStart = stevilka.length;
            var iLength = field1.value.length;
            if (field1.createTextRange) {
                var oRange = field1.createTextRange();
                oRange.moveStart("character", iStart);
                oRange.moveEnd("character", iLength - iStart);
                oRange.select();
            } else if (field1.setSelectionRange) {
                field1.setSelectionRange(iStart, iLength);
            }
        } else if (key == 8 || key == 46) {
            field1.value = '';
            field2.value = '';
        } else {
            field2.value = '';
        }
        field1.focus();
    }).fail(function (r, e) {
        console.log(r);
        console.log(e);
    });
}

/******************************************************************************/
function isNumeric(num) {
    return !isNaN(parseFloat(num)) && isFinite(num);
}
/******************************************************************************/
function isNumber(num) {
    return !isNaN(parseFloat(num)) && isFinite(num);
}
/******************************************************************************/
function fNumToStr(num, decimal) {
    if (isNumber(num)) {
        if (isNumber(decimal)) {
            num = Math.round(Math.pow(10, decimal) * (num)) / Math.pow(10, decimal);
            num = num.toFixed(decimal);
        }
        num = num.toString();
        num = num.replace(".", ",");
    }
    return num;
}
/******************************************************************************/
function fStrToNum($str) {
    var $dotPos = $str.lastIndexOf("."),
        $commaPos = $str.lastIndexOf(","),
        $sep,
        $int,
        $dec,
        $result;
    $sep = (($dotPos > $commaPos) && $dotPos) ? $dotPos :
        ((($commaPos > $dotPos) && $commaPos) ? $commaPos : false);

    if (!$sep) {
        return parseFloat($str.replace(/([^a-z0-9]+)/i, ''));
    }
    $int = $str.substr(0, $sep);
    $dec = $str.substr($sep + 1);
    $int = $int.replace(/([^a-z0-9]+)/i, '');
    $dec = $dec.replace(/([^a-z0-9]+)/i, '');
    return parseFloat($int + '.' + $dec);
    /*
    var res = str.replace(/,/g, ".");
    if (!isNumber(res)) {
        res = str;
    }
    return res;
    */
}
/******************************************************************************/
function trim(str, charlist) {
    str += '';
    if (!charlist) {
        whitespace = " \n\r\t\f\x0b\xa0\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u200b\u2028\u2029\u3000";
    } else {
        // preg_quote custom list
        charlist += '';
        whitespace = charlist.replace(/([\[\]\(\)\.\?\/\*\{\}\+\$\^\:])/g, '$1');
    }
    for (i = 0; i < str.length; i++) {
        if (whitespace.indexOf(str.charAt(i)) === -1) {
            str = str.substring(i);
            break;
        }
    }
    for (i = str.length - 1; i >= 0; i--) {
        if (whitespace.indexOf(str.charAt(i)) === -1) {
            str = str.substring(0, i + 1);
            break;
        }
    }
    return whitespace.indexOf(str.charAt(0)) === -1 ? str : '';
}
/******************************************************************************/
function kosarica_natisni(kosarica, subdir) {
    window.open(subdir + 'includes/kosarica_natisni.php?p_mode=natisni&p_kosarica=' + kosarica);
}
/******************************************************************************/
function kosarica_preklici() {
    if (confirm('Ali res želte preklicati nakup?')) {
        document.kosarica_uredi.p_request.value = 'preklici_zakljucen';
        document.kosarica_uredi.submit();
    }
}
/******************************************************************************/
function showLocalImage(imgname) {
    imgname = imgname.replace(/\\/g, "/");
    imgname = imgname.replace(/\’/g, "\\'");
    content = "<img src=\"" + String(imgname) + "\" />";
    alert(document.artikel_slika_uredi.userfile.value);
    eval(document.getElementById('imagepreview').innerHTML = content);
    document.getElementById('imagepreview').style.visibility = 'visible';
}
/******************************************************************************/
function calcImageSize(imgWidth, imgHeight, maxImgSize) {
    var imageDimensions = {},
        ratio = 1;
    imageDimensions.width = imgWidth;
    imageDimensions.height = imgHeight;
    if (trim(maxImgSize) === '' || maxImgSize === undefined) {
        maxImgSize = 180;
    }
    if (imgWidth / imgHeight >= 1) {
        ratio = maxImgSize / imgWidth;
        imageDimensions.height = Math.round(imgHeight * ratio);
        imageDimensions.width = maxImgSize;
    } else {
        ratio = maxImgSize / imgHeight;
        imageDimensions.width = Math.round(imgWidth * ratio);
        imageDimensions.height = maxImgSize;
    }
    if (imageDimensions.width > imgWidth || imageDimensions.height > imgHeight) {
        ratio = Math.min(imgWidth / imageDimensions.width, imgHeight / imageDimensions.height);
        imageDimensions.width = imageDimensions.width * ratio;
        imageDimensions.height = imageDimensions.height * ratio;
    }
    return imageDimensions;
}
/******************************************************************************/
function handleFileSelect(fileInput, ImagePreviewBox, ImagePreviewId, maxImgSize) {
    var files = document.getElementById(fileInput).files,
        imageDimensions = {}; // FileList object
    // Loop through the FileList and render image files as thumbnails.
    if ((typeof ImagePreviewId === 'undefined') || ImagePreviewId === '') {
        ImagePreviewId = 'imagePreview';
    }
    if ((typeof ImagePreviewBox === 'undefined') || ImagePreviewBox === '') {
        ImagePreviewBox = '#imgPreview';
    }
    for (var i = 0, f; f = files[i]; i++) {
        // Only process image files.
        if (!f.type.match('image.*')) {
            continue;
        }
        var reader = new FileReader();
        // Closure to capture the file information.
        reader.onload = (function (theFile) {
            return function (e) {
                var imagePreview = $('#' + ImagePreviewId);
                imagePreview.remove();
                var img = new Image();
                $(img).on("load", function () {
                    var imagePreview = $('#' + ImagePreviewId);
                    var imgWidth = imagePreview.width();
                    var imgHeight = imagePreview.height();
                    imageDimensions = calcImageSize(imgWidth, imgHeight, maxImgSize);
                    imagePreview.css({
                        height: imageDimensions.height + 'px',
                        width: imageDimensions.width + 'px'
                    });
                    imagePreview.fadeIn('slow');
                });
                img.src = e.target.result;
                $(ImagePreviewBox).wrapInner('<img src="' + img.src + '" title="' + theFile.name + '" id="' + ImagePreviewId + '" style="display:none;"/>');
                //   document.getElementById('imgPreview').innerHTML = ['<img src="', img.src,'" title="', theFile.name, '" id="img" style="display:none;" />'].join('');
            };
        })(f);
        // Read in the image file as a data URL.
        reader.readAsDataURL(f);
    }
}
/******************************************************************************/
function fIsDate(pThis, pObvezenVnos) {

    var dateVal = "";
    var obvezenVnos;

    if (pObvezenVnos === undefined) {
        obvezenVnos = false;
    } else {
        obvezenVnos = pObvezenVnos;
    }

    if (pThis && typeof pThis === "object") {
        // pThis je DOM element
        dateVal = pThis.value.trim();
    } else if (pThis && typeof pThis === "string") {
        if (document.getElementById(pThis)) {
            // pThis je ID DOM elementa
            dateVal = document.getElementById(pThis).value.trim();
        } else {
            // pThis je datumska vrednost
            dateVal = pThis.trim();
        }
    }

    if (dateVal === "") {
        if (obvezenVnos) {
            alert("Datum ne sme biti prazen");
            return false;
        } else {
            return true;
        }
    }

    // dovoljen vzorec datuma __.__.____  ce hoces se kaj dodati, uporabi | - to je ali
    var datePat = /^(\d{1,2})(\.)(\d{1,2})(\.)(\d{4})$/;
    var matchArray = dateVal.match(datePat);

    if (matchArray === null) {
        alert("Datum mora imeti obliko dd.mm.yyyy");
        document.getElementById(pThis).value = '';
        document.getElementById(pThis).focus();
        return false;
    }

    day = matchArray[1];
    month = matchArray[3];
    year = matchArray[5];

    if (month < 1 || month > 12) {
        alert("Mesec mora biti med 1 in 12");
        return false;
    }

    if (day < 1 || day > 31) {
        alert("Dan mora biti med 1 in 31");
        return false;
    }

    if ((month == 4 || month == 6 || month == 9 || month == 11) && day == 31) {
        alert("Mesec " + month + " nima 31 dni");
        return false;
    }

    if (month == 2) {
        var isleap = (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0));
        if (day > 29 || (day == 29 && !isleap)) {
            alert("Februar " + year + " nima " + day + " dni");
            return false;
        }
    }

    return true;
}

/**
Funkcija formatira datum v obliko dd.mm.yyyy
sprejema formate:
 - d, dd           :dan manjši od 10 lahko brez vodilne 0; vrne dd."trenutni mesec"."trenutno leto"
 - d., dd.         :dan manjši od 10  brez vodilne 0; vrne 0d."trenutni mesec"."trenutno leto"
 - ddmm            :dan in mesec manjši od 10 morata imeti vodilno 0; vrne dd.mm."trenutno leto"
 - d.m, dd.mm      :dan ali mesec manjši od 10 lahko brez vodilne 0; vrne dd.mm."trenutno leto"
 - d.m., dd.mm.    :dan ali mesec manjši od 10 lahko brez vodilne 0; vrne dd.mm."trenutno leto"
 - ddmmyy          :dan in mesec manjši od 10 morata imeti vodilno 0, letnica na dve mesti; vrne dd.mm.yyyy
 - ddmmyyyy        :dan in mesec manjši od 10 morata imeti vodilno 0, letnica na štiri mesta; vrne dd.mm.yyyy
 - d.m.y, dd.mm.yy :dan, mesec ali leto manjše od 10 lahko brez vodilne 0; vrne dd.mm.yyyy
                    dvomestna letnica pomeni 20yy če je yy < 30 in 19yy če je yy >= 30
*/
function fFormatDate(date) {
    var numDots = date.length - (date.replace(/\./g, "")).length,
        dateLength = date.length,
        newDate = "",
        today = new Date(),
        month = today.getMonth() + 1;

    if (month < 10) {
        month = "0" + month;
    }

    var year = today.getFullYear();
    var allowedLength = [1, 2, 4, 6, 8];

    if (dateLength === 0) {
        return newDate;

    } else if (dateLength == 10 && numDots == 2) {
        newDate = date;

    } else if (numDots > 0) {
        var dateArray = date.split(".");

        if (dateArray[0].length == 1) {
            newDate = "0" + dateArray[0];
        } else {
            newDate = dateArray[0];
        }

        if (dateArray[1] === undefined || dateArray[1] === "") {
            newDate = newDate + "." + month;

        } else if (dateArray[1].length == 1) {
            newDate = newDate + ".0" + dateArray[1];

        } else {
            newDate = newDate + "." + dateArray[1];

        }

        if (dateArray[2] === undefined || dateArray[2] === "") {
            newDate = newDate + "." + year;

        } else if (dateArray[2].length == 1) {

            if (dateArray[2] < 30) {
                newDate = newDate + ".200" + dateArray[2];
            } else {
                newDate = newDate + ".190" + dateArray[2];
            }

        } else if (dateArray[2].length == 2) {
            if (dateArray[2] < 30) {
                newDate = newDate + ".20" + dateArray[2];
            } else {
                newDate = newDate + ".19" + dateArray[2];
            }

        } else if (dateArray[2].length == 4) {
            newDate = newDate + "." + dateArray[2];
        }

    } else if (dateLength == 1) {
        newDate = "0" + date + "." + month + "." + year;

    } else if (dateLength == 2) {
        newDate = date + "." + month + "." + year;

    } else if (dateLength == 4) {
        newDate = date.slice(0, 2) + "." + date.slice(2, 4) + "." + year;

    } else if (dateLength == 6) {
        if (date.slice(4, 6) < 30) {
            year = "20" + date.slice(4, 6);
        } else {
            year = "19" + date.slice(4, 6);
        }
        newDate = date.slice(0, 2) + "." + date.slice(2, 4) + "." + year;

    } else if (dateLength == 8) {
        newDate = date.slice(0, 2) + "." + date.slice(2, 4) + "." + date.slice(4, 8);
    }
    return newDate;
}

function formatDate(pThis) {
    var obj,
        date;
    if (pThis && typeof pThis === "object") {
        obj = pThis;
        date = pThis.value.trim();
    } else {
        obj = document.getElementById(pThis);
        date = document.getElementById(pThis).value.trim();
    }

    newDate = fFormatDate(date);


    if (!fIsDate(newDate)) {
        obj.focus();
        obj.setSelectionRange(0, dateLength);
        return false;

    } else {
        if (newDate != date) {
            obj.value = newDate;
        }
    }
}
// Da dobimo dvo mestno cifro (z vodilno nulo, če je string manjši od dveh mest oz. odrežemo nulo na začetku, če je string daljši od dveh mest)
function preveriDolzino(cas) {
    var tmp = '' + cas + '';

    // Dodamo vodilno nulo
    if (tmp.length < 2) {
        tmp = "0" + tmp;
    }

    // Odstranimo nulo, če je string dalši od dveh mest
    if (tmp.length > 2 && tmp.indexOf("0") === 0) {
        tmp = tmp.substring(1, tmp.length);
    }

    return tmp.trim();
}

// Funkcija, ki vrne tip objekta
var toType = function (obj) {
    return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
};
/******************************************************************************/
// Preverimo format ure
//  @param id - ID elementa, ki vsebuje string za parsanje ($(this)) ali pa samo string
//  @param ura24 - true, potem ne smemo preseči vnosa "23:59"
function preveriFormatUre(id, ura24) {
    var cas = null,
        tmp = null,
        ura = "00",
        minuta = "00",
        tmpArr = [],
        tip = null,
        g_ura = null,
        g_minuta = null;
    var tipID = 0; // 0 - $(this), 1 - string

    if (toType(id) == "object") {
        tipID = 0;
        tmp = '' + id.val().trim() + '';
    } else if (toType(id) == "string") {
        tipID = 1;
        tmp = id;
    } else {
        return;
    }
    if (tmp === '') {
        return;
    }
    // Stringi z :
    if (tmp.indexOf(":") >= 0) {
        ura = "00";
        minuta = "00";

        tmpArr = tmp.split(":");
        if (tmpArr[0] !== null && tmpArr[0] !== "") {
            ura = tmpArr[0];
        }
        if (tmpArr[1] !== null && tmpArr[1] !== "") {
            minuta = tmpArr[1];
        }

        tip = 1;
        g_ura = preveriDolzino(ura);
        g_minuta = preveriDolzino(minuta);
    }

    // Preverimo ali string vsebuje , oz. .
    if (tmp.indexOf(",") >= 0) {
        // zamenjamo , v .
        tmp = tmp.replace(",", ".");
    }
    if (tmp.indexOf(".") >= 0) {
        tmpArr = tmp.split(".");
        ura = tmpArr[0];
        minuta = tmpArr[1];
        var delez = Number("0." + minuta);

        minuta = Math.round(60 * delez);

        tip = 2;
        g_ura = preveriDolzino(ura);
        g_minuta = preveriDolzino(minuta);
    }

    // Preverimo ali string NE vsebuje :
    if (tmp.indexOf(":") < 0 && tmp.indexOf(",") < 0 && tmp.indexOf(".") < 0) {
        // Cifra vecja ali enaka 4 mesta
        if (tmp.length >= 4) {
            ura = tmp.substring(0, tmp.length - 2);
            minuta = tmp.substring(tmp.length - 2, tmp.length);
            tip = 3;
        }
        // Cifra med 1 in 999, posebaj 0xx
        else if (tmp.length >= 1 && tmp.length <= 3) {
            if (tmp.substring(0, 1) == '0') {
                ura = "00";
                minuta = tmp.substring(tmp.length - 2, tmp.length);
                tip = 4;
            } else {
                if (tmp.length == 1 || tmp.length == 2) {
                    ura = tmp.substring(0, tmp.length);
                    minuta = "00";
                }
                if (tmp.length == 3) {
                    ura = tmp.substring(0, 1);
                    minuta = tmp.substring(tmp.length - 2, tmp.length);
                }
                tip = 5;
            }
        }

        g_ura = preveriDolzino(ura);
        g_minuta = preveriDolzino(minuta);
    }

    // Preverim minute
    while (g_minuta >= 60) {
        g_ura = preveriDolzino(parseInt(ura) + 1);
        g_minuta = preveriDolzino(parseInt(g_minuta) - 60);
    }

    g_ura = preveriDolzino(g_ura);
    g_minuta = preveriDolzino(g_minuta);

    // Preverimo število ur, če je parameter nastavljen
    if ((tipID === 0 && id.hasClass("ura24")) || (tipID === 1 && ura24 !== undefined && ura24 === true)) {
        if (g_ura >= 24) {
            alert("Format ure mora biti manjši od 24 ur (max: 23:59).\nVnešeno: " + g_ura + ":" + g_minuta);
            if (tipID === 0) {
                id.val('');
                id.focus();
            } else {
                return null;
            }
            return;
        }
    }

    // Vrnemo datum ali napako
    if (g_ura === null || g_minuta === null || isNaN(g_ura) || isNaN(g_minuta)) {
        alert("Vnesite pravilni format ure!\nMožnosti: (h, hh, hmm, hhmm, hhhmm, 0mm, h.m, .m, h:m, hh:m, hh:mm, hhh:mm, :mm)!\n\nVnešeno: " + tmp);
        if (tipID === 0) {
            id.val('');
            id.focus();
        } else {
            return null;
        }
    } else {
        cas = g_ura + ":" + g_minuta;

        if (tipID === 0) {
            id.val(cas);
        } else {
            return cas;
        }
    }
}
/******************************************************************************/
function getOffset(el) {
    var _x = 0;
    var _y = 0;
    while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
        _x += el.offsetLeft - el.scrollLeft;
        _y += el.offsetTop - el.scrollTop;
        el = el.offsetParent;
    }
    return {
        top: _y,
        left: _x
    };
}
/******************************************************************************/
/******************************************************************************/
equalheight = function (container) {
    var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = [],
        $el,
        topPosition = 0;
    $(container).each(function () {
        $el = $(this);
        $($el).height("auto");
        topPostion = $el.position().top;
        if (currentRowStart != topPostion) {
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }
            rowDivs.length = 0; // empty the array
            currentRowStart = topPostion;
            currentTallest = $el.height();
            rowDivs.push($el);
        } else {
            rowDivs.push($el);
            currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
        }
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
        }
    });
};
/******************************************************************************/
function getWindowWidth() {
    return $(window).width();
}
/******************************************************************************/
function getWindowHeight() {
    return $(window).height();
}
/******************************************************************************/
function fGetParentWidth() {
    var width = $(window).width();
    try {
        width = parent.getWindowHWidth();
    } catch (err) {
        width = $(window).width();
    }
    return width;
}
/******************************************************************************/
function fGetParentHeight() {
    var height = $(window).height();
    try {
        height = parent.getWindowHeight();
    } catch (err) {
        height = $(window).height();
    }
    return height;
}
/******************************************************************************/
function isEven(n) {
    return n % 2 === 0;
}
/******************************************************************************/
function isOdd(n) {
    return Math.abs(n % 2) == 1;
}
/******************************************************************************/
function scaleMap(selector) {
    var $ratio = $("#" + selector).parent().width() / $("#" + selector).width();
    var $newWidth = $("#" + selector).width() * $ratio;
    var $newHeight = $("#" + selector).height() * $ratio;
    if ($ratio < 1) {
        $("#" + selector).width($newWidth);
        $("#" + selector).height($newHeight);
    }
}
/******************************************************************************/
function fPageIndexPageLink(page,
    page_index_url,
    page_active) {
    var active = '';
    if (page_active === page) {
        active = ' class="active"';
    }
    return '<li><a href="#" data-screen="' + page + '" ' + active + '><span>' + page + '</span></a></li>';
    // return '<li><a href="' + page_index_url + '&amp;screen=' + page + '" data-screen="' + page + '" '+ active + '><span>' + page + '</span></a></li>';
}
/******************************************************************************/
function pCreatePageIndex(target,
    pages_total,
    page_active,
    pages_visible,
    page_index_url,
    page_text) {
    var page_index;
    if (pages_total > 1) {
        var prev_screeen = Math.max(page_active - 1, 1);
        var next_screeen = Math.min(page_active + 1, pages_total);
        var start_page = Math.max(Math.floor(pages_visible / 2), 1);
        var stop_page = Math.min(start_page + pages_visible - 1, pages_total);
        var pages_page_index = '';
        for (i = start_page; i <= stop_page; i++) {
            pages_page_index += fPageIndexPageLink(i, page_active, page_index_url);
        }
        page_index = '' +
            '<div class="page-index">' +
            '<div class="page-index-num-pages">' + stran_text + '</div>' +
            '<div class="page-index-pages">' +
            '<ul>' +
            '<li><a href="#" data-screen="1"><span>&lt;&lt;</span></a></li>' +
            '<li><a href="#" data-screen="' + prev_screeen + '"><span>&lt;</span></a></li>' +
            pages_page_index +
            '<li><a href="#" data-screen="' + next_screeen + '"><span>&gt;</span></a></li>' +
            '<li><a href="#" data-screen="' + pages_total + '"><span>&gt;&gt;</span></a></li>' +
            /*
            '<li><a href="' + page_index_url + '&amp;screen=1" data-screen="1"><span>&lt;&lt;</span></a></li>' +
            '<li><a href="' + page_index_url + '&amp;screen=' + prev_screeen + '" data-screen="' + prev_screeen + '"><span>&lt;</span></a></li>' +
            pages_page_index +
            '<li><a href="' + page_index_url + '&amp;screen=' + next_screeen + '" data-screen="' + next_screeen + '"><span>&gt;</span></a></li>' +
            '<li><a href="' + page_index_url + '&amp;screen=' + pages_total + '" data-screen="' + pages_total + '"><span>&gt;&gt;</span></a></li>' +
            */
            '</ul>' +
            '</div>' +
            '/div>';
        $("#" + target).html(page_index);
    }
}
/******************************************************************************/
var fixTrSortableHelper = function (e, ui) {
    var width;
    var header = ui.closest("table").find("thead > tr").eq(0);
    ui.children("td").each(function (index) {
        width = $(this).width();
        $(this).width(width);
        header.find("th").eq(index).width(width);
    });
    return ui;
};
/******************************************************************************/
function pCreateVatDropdown(obj, name, id, date, selected) {
    $("#" + obj).append('<select name="' + name + '" id="' + id + '" class="textinputbel"></select>');
    $("#" + id).append(fGetVatOptions(date, selected));
}
/******************************************************************************/
function fGetVatOptions(date, selected, target) {
    var options = '',
        is_selected;
    $.ajax({
        async: true,
        type: "GET",
        url: "/admin/ajax/admin.get.php",
        data: {
            "ajaxDataGet": "fmGetVatRates",
            "p_date": date,
            "p_timestamp": new Date().getTime()
        }
    }).done(function (r) {
        $(r).each(function (idx, result) {
            is_selected = '';
            if (result.vat_rate === selected) {
                is_selected = ' selected="selected"';
            }
            options += '<option value="' + result.vat_rate + '"' + is_selected + '>' + result.vat_rate_name + '</option>';
        });
        $(target).html(options);
    });
}
/******************************************************************************/
function fgetVatRates(date) {
    var vat_rates = [];
    $.ajax({
        async: false,
        type: "GET",
        url: "/content/arsluna.proccess.php",
        data: {
            "p_request": "fmGetVatRates",
            "p_date": date,
            "p_timestamp": new Date().getTime()
        }
    }).done(function (r) {
        vat_rates = r;
    });
    return vat_rates;
}
/******************************************************************************/
function expandDetails(el, childClass) {
    if ($(el).hasClass('show-details')) {
        $(childClass).each(function () {
            $(this).hide();
        });
        $(el).removeClass('show-details');
    } else {
        $(childClass).each(function () {
            $(this).show();
        });
        $(el).addClass('show-details');
    }
}
/******************************************************************************/
function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return false;
    }
    return false;
}
/******************************************************************************/
function pSetLength(elem, target) {
    var content, length;
    content = $(elem).val();
    length = content.length;
    length = (isNumber(length) ? length : 0);
    $(target).html(length);
    if (length > $(target).data("max_length")) {
        $(target).addClass("has-error");
    } else if (length < $(target).data("min_length")) {
        $(target).addClass("has-error");
    } else {
        $(target).removeClass("has-error");
    }
}
/******************************************************************************/
function pSetMessageBoxHeight() {
    var windowHeight = getWindowHeight() * 0.9,
        outerHeight;

    $("#message-box").css('height', 'auto');
    outerHeight = $("#message-box").outerHeight();
    if (outerHeight > windowHeight) {
        $("#message-box").height(windowHeight);
        $("#message-box").css("overflow-y", "auto");
    } else {
        // $("#message-box").height(outerHeight);
        $("#message-box").css("overflow-y", "");
    }
}

function pSetAlertifyDialogIframePosition() {
    var offset, alertify_offset;
    if (inIframe()) {
        if (!$("#alertify_offset").length) {
            $("head").append('<style id="alertify_offset"></style>');
        }
        console.log($("#arsluna-editor-simple", parent.document));
        if ($("#page-content-editor", parent.document).length > 0) {
            offset = $("#page-content-editor", parent.document).offset();
        } else {
            offset = $("#arsluna-editor-simple", parent.document).offset();
        }
        alertify_offset = Math.max($(window.parent).scrollTop() - offset.top, 0) + 50;
        $("#alertify_offset").text(".alertify .dialog{top: " + alertify_offset + "px}");
    }
}

/**
 * Creates a string that can be used for dynamic id attributes
 * Example: "id-so7567s1pcpojemi"
 * @returns {string}
 */
var uniqueId = function () {
    return 'arsluna_id-' + Math.random().toString(36).substr(2, 16);
};
/******************************************************************************/
function rgb2hex(rgb) {
    if (/^#[0-9A-F]{6}$/i.test(rgb)) return rgb;
    if (!rgb | rgb === null) return rgb;
    rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    if (!rgb | rgb === null) return rgb;

    function hex(x) {
        return ("0" + parseInt(x).toString(16)).slice(-2);
    }
    return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
}
/******************************************************************************/
function styleToArray(style) {
    var styles,
        i,
        array = {},
        k, v;
    if (style === "" | style === undefined) {
        array = {};
        return array;
    }
    styles = style.split(';');
    i = styles.length;
    while (i--) {
        style = styles[i].split(':');
        k = trim(style[0]);
        v = trim(style[1]);
        if (k.length > 0 && v.length > 0) {
            array[k] = v;
        }
    }
    return array;
} // END styleToArray
